import { render, staticRenderFns } from "./related_work_items.vue?vue&type=template&id=9dd8c874"
import script from "./related_work_items.vue?vue&type=script&lang=js"
export * from "./related_work_items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports